import { useRef } from "react";

import DialogInOne from "../../../../components/DialogInOne";
import { Button } from "../../../../components/MuiGenerals";
import { useAlerting, useTranslation } from "../../../../hooks";
import { useCreateSwapRequestContext } from "../context";
import { ISwapPathInfo } from "../../../../api/swap";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

const SwapPathResponseDialogForQA = ({ isOpen, onClose }: IProps) => {
  const { swapPaths, filterFields, setSwapPaths } =
    useCreateSwapRequestContext();

  const apiSwapPathsRef = useRef<ISwapPathInfo[]>();

  const { t, tc } = useTranslation("createSwapRequest");

  const { alerting } = useAlerting();

  const { fromCurrency, toCurrency } = filterFields;

  const getTargetPathInfo = (swapPaths: ISwapPathInfo[]) => {
    return swapPaths.find((pathInfo) => {
      return (
        pathInfo.asset_name_from === fromCurrency &&
        pathInfo.asset_name_to === toCurrency
      );
    });
  };

  const targetPathInfo = getTargetPathInfo(swapPaths);

  const resetPathInfo = getTargetPathInfo(apiSwapPathsRef.current || swapPaths);

  const swapPathTextAreaRef = useRef<HTMLTextAreaElement | null>(null);

  const config = {
    title: t("swapPathResponse"),
    self: {
      open: isOpen,
      onClose: onClose,
    },
    content: (
      <textarea
        style={{
          whiteSpace: "pre-wrap",
          lineHeight: "1.5",
          fontFamily: "monospace",
          fontSize: "16px",
          padding: "10px",
          overflowX: "auto",
          width: "100%",
        }}
        ref={swapPathTextAreaRef}
      >
        {targetPathInfo?.contract_swap_path}
      </textarea>
    ),
    onCancel: onClose,
    actionButtons: (
      <Button
        {...{
          color: "info",
          variant: "contained",
          children: tc("reset"),
          onClick: () => {
            if (!swapPathTextAreaRef.current) {
              return;
            }

            swapPathTextAreaRef.current.value =
              resetPathInfo?.contract_swap_path || "";
          },
        }}
      />
    ),

    onConfirm: () => {
      try {
        JSON.parse(swapPathTextAreaRef.current?.value || "");
      } catch (error) {
        alerting("warning", t("invalidJsonFormat"));
        return;
      }

      apiSwapPathsRef.current = apiSwapPathsRef.current || swapPaths;

      const newSwapPaths = swapPaths.map((pathInfo) => {
        if (
          pathInfo.asset_name_from === fromCurrency &&
          pathInfo.asset_name_to === toCurrency
        ) {
          return {
            ...pathInfo,
            contract_swap_path: swapPathTextAreaRef.current?.value || "",
          };
        }
        return pathInfo;
      });

      setSwapPaths(newSwapPaths);
      onClose();
    },
  };

  return <DialogInOne {...config} />;
};

export default SwapPathResponseDialogForQA;
